import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'duration'
})
export class DurationPipe implements PipeTransform {

  transform(value: number | null | undefined, format: 'hms' | 'dhm' = 'hms'): string {
    if (value === null || value === undefined) {
      return format === 'dhm' ? '---' : '00:00:00';
    }

    const totalSeconds = Math.floor(value);

    if (format === 'dhm') {
      const days    = Math.floor(totalSeconds / 86400);
      const hours   = Math.floor((totalSeconds % 86400) / 3600);
      const minutes = Math.floor((totalSeconds % 3600) / 60);

      const parts: string[] = [];
      if (days > 0)    parts.push(`${days}d`);
      if (hours > 0)   parts.push(`${hours}h`);
      if (minutes > 0) parts.push(`${minutes}min`);
      return parts.length ? parts.join(' ') : '0min';
    }

    const hours   = Math.floor(totalSeconds / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    const seconds = totalSeconds % 60;

    return [
      this.formatTimeUnit(hours),
      this.formatTimeUnit(minutes),
      this.formatTimeUnit(seconds)
    ].join(':');
  }

  private formatTimeUnit(value: number): string {
    return value.toString().padStart(2, '0');
  }

}
